// libraries
import clsx from 'clsx'

// types
interface Props {
    className?: string
    bgColor?: 'green' | 'beige' | 'green-light' | 'white' | 'hard-white'
    children: React.ReactNode
}

// css
import './index.scss'

export default function RoundedBox({
    className,
    bgColor,
    children
}: Props) {
    return (
        <div
            className={clsx(
                'rounded-box-component',
                bgColor && `bg-${bgColor}`,
                className
            )}
            data-rounded-box
        >
            {children}
        </div>
    )
}